import moment from 'moment'

import 'react-datepicker/dist/react-datepicker.css'
import { ReactCalendar } from '../date-picker/ReactCalendar'
export const FormDataPicker: React.FC<{
  field: {
    name: string
    value: any
    onChange: () => void
  }
  form: {
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  }
  className: string
  disabled?: boolean
  onDateChange: (value: Date, e: React.ChangeEvent<HTMLInputElement> | undefined) => void
  maxDate?: Date
  minDate?: Date

}> = (props) => {

  const handlerChange = (value: Date, e: React.ChangeEvent<HTMLInputElement> | undefined) => {
    props.onDateChange(value, e)
  }

  return (
    <>
      <ReactCalendar
        name={props.field.name}
        value={props.field.value}
        className={props.className}
        disabled={props.disabled}
        onChange={handlerChange}
        maxDate={props.maxDate}
        minDate={props.minDate}
      />
    </>
  )
}
